import { io } from "socket.io-client";

const WEr4u_URL = process.env.REACT_APP_API_URL;
const TUNNEL_URL = "https://rnd3nxqq-5500.usw3.devtunnels.ms/";
const TEST = process.env.REACT_APP_TEST_URL;
 const SAAS_URL = process.env.REACT_APP_SAAS_URL;

export const socketWex = io(SAAS_URL, {
  autoConnect: false,
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
});

export const setSocketsAgent = (agentId) => {
  socketWex.auth = { agent: agentId };
};
